import { useState, useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { getApolloClient } from '@confluence/graphql';
import type { TemplateLabelType } from '@confluence/template-utils/entry-points/useTemplateEditorLabels';

import { ALLOWED_CONTENT_STATUSES, ContentTypes } from '../constants';

import { LabelsCountQuery } from './LabelCountQuery.graphql';

const i18n = defineMessages({
	edit: {
		id: 'labels.modal.title.edit-label',
		defaultMessage: 'Edit labels',
		description: 'Title for modal to edit content labels',
	},
	add: {
		id: 'labels.modal.title.add-label',
		defaultMessage: 'Add labels',
		description: 'Title for modal to add content labels',
	},
});

export const useLabelsDescriptionText = ({
	contentId,
	contentType,
	labels,
}: {
	contentId: string;
	contentType?: string;
	labels?: Array<TemplateLabelType>;
}): string => {
	const { formatMessage } = useIntl();
	const [hasLabels, setHasLabels] = useState<boolean | null>(null);

	useEffect(() => {
		const apolloClient = getApolloClient();

		async function checkHasLabels() {
			if (contentType === ContentTypes.TEMPLATE) {
				const labelCount = labels?.length || 0;
				setHasLabels(labelCount > 0);
			} else {
				const { data } = await apolloClient.query({
					query: LabelsCountQuery,
					variables: {
						contentId,
						status: ALLOWED_CONTENT_STATUSES,
					},
				});
				setHasLabels(data?.singleContent?.labels?.count > 0);
			}
		}
		void checkHasLabels();
	}, [contentId, contentType, labels]);

	return typeof hasLabels === 'boolean' ? formatMessage(hasLabels ? i18n.edit : i18n.add) : '';
};
